import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "store-locators-result"
}
const _hoisted_2 = { class: "results-list" }
const _hoisted_3 = {
  key: 0,
  class: "container-custom"
}
const _hoisted_4 = { class: "title" }
const _hoisted_5 = ["id", "onClick"]
const _hoisted_6 = { class: "container-custom" }
const _hoisted_7 = { class: "d-flex w-100 position-relative" }
const _hoisted_8 = { style: {"float":"1"} }
const _hoisted_9 = {
  key: 0,
  class: "float-end franchising-point",
  style: {"float":"1","position":"absolute","margin-right":"-10px","right":"0 !important"}
}
const _hoisted_10 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_ctx.showResults)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.storeLocators, (s, i) => {
            return (_openBlock(), _createElementBlock("div", {
              key: 'group-' + i,
              class: "results-category"
            }, [
              (_ctx.hasProvince)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _createElementVNode("label", _hoisted_4, _toDisplayString(s[0].province), 1)
                  ]))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(s, (store) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: 'store-' + store.id,
                  id: store.id,
                  class: _normalizeClass(["col-12 result-store cursor-pointer", 
            _ctx.selectedStoreLocator &&
            _ctx.selectedStoreLocator.id === store.id &&
            'active'
          ]),
                  onClick: ($event: any) => (_ctx.onSelect(store))
                }, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("h3", _hoisted_7, [
                      _createVNode(_component_font_awesome_icon, {
                        icon: _ctx.FaMapMarker,
                        "aria-hidden": true,
                        style: {"float":"1"}
                      }, null, 8, ["icon"]),
                      _createElementVNode("a", _hoisted_8, _toDisplayString(store.name), 1),
                      (store.franchising)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_9))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("span", null, _toDisplayString(store.address), 1),
                    _createElementVNode("span", null, _toDisplayString(store.cap) + " " + _toDisplayString(store.city) + " (" + _toDisplayString(store.provinceCode) + ") ", 1),
                    (store.telephone)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(store.telephone), 1))
                      : _createCommentVNode("", true)
                  ])
                ], 10, _hoisted_5))
              }), 128))
            ]))
          }), 128))
        ])
      ]))
    : _createCommentVNode("", true)
}